module.exports = __webpack_public_path__ + "static/media/Instrução de trabalho_Disponibilidade_contratual.e10857f1.pdf";